import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useForm } from 'react-hook-form';

import { CactusLabelInput } from '../../../components';
import useFormValidatorEmail from '../../../hooks/validators/use-form-validator-email';
import AuthService from '../../../services/use_case/auth/AuthService';

type ForgotPasswordInputs = {
    email: string;
};

const ForgotPassword: React.FC = () => {

    const [t] = useTranslation();
    const { handleSubmit, register, errors } = useForm<ForgotPasswordInputs>();
    const [isLoading, setIsLoading] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);

    const emailRegister = register(useFormValidatorEmail());

    const _handleOnSubmit = async (data: ForgotPasswordInputs) => {
        setIsLoading(true);
        try {
            await new AuthService().forgotPassword(data.email);
            setIsSuccess(true);
        } catch {
            // errors handled by BaseService via iziToast
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="auth">
            <div className="box-center">
                <div className="auth__wrapper">
                <div className="auth__box">
                    <div className="row">

                        <div className="col-12 col-md-6">
                            <div className="d-flex justify-content-center align-items-center h-100">
                                <img className="auth__logo" src={process.env.REACT_APP_AUTH_LOGO_URI || '/img/logo-cactus.png'} alt="logo" />
                            </div>
                        </div>

                        <div className="col-12 col-md-6 auth__form">
                            <p className="auth__heading">{t('forgot_password_heading')}</p>
                            <p className="auth__subheading">{t('forgot_password_subtitle')}</p>

                            {isSuccess ? (
                                <p className="auth__success-msg">{t('forgot_password_success')}</p>
                            ) : (
                                <form onSubmit={handleSubmit(_handleOnSubmit)}>
                                    <CactusLabelInput
                                        labelTitle={t('Email')}
                                        inputAttributes={{
                                            id: 'email',
                                            name: 'email',
                                            type: 'email',
                                            placeholder: '*****@email.com',
                                            autoComplete: 'email',
                                            ref: emailRegister,
                                        }}
                                        errorMessage={errors.email ? errors.email.message : null}
                                    />
                                    <div className="d-flex justify-content-end mt-2">
                                        <button
                                            type="submit"
                                            className="btn btn-cactus"
                                            disabled={isLoading}
                                        >
                                            {isLoading
                                                ? <span className="auth__btn-spinner" />
                                                : t('forgot_password_submit')
                                            }
                                        </button>
                                    </div>
                                </form>
                            )}
                        </div>

                    </div>
                </div>

                <p className="auth__register-hint">
                    <Link to="/login">{t('forgot_password_back_login')}</Link>
                </p>
                </div>
            </div>
        </div>
    );

};

export default React.memo(ForgotPassword);
